<template>
		<div
		class="list-process">
		<div class="process-image">
			<text-graphic :data="process" class='process-title'/>
			<box-blue
				:data="process"
				:enabled='process.enabled'
			/>
		</div>
		<div v-if="index !== 2" class="process-arrow">
			<img
				src='/static/img/evaluation/right-arrow.svg'
				alt="flecha derecha">
		</div>
	</div>
</template>

<script>
import boxBlue from '@/modules/job-evaluation/components/box-blue';
import textGraphic from '@/modules/job-evaluation/components/text-graphic';

export default {
	name: 'process-option',
	props: ['process', 'index'],
	components: { boxBlue, textGraphic },
};
</script>

<style scoped>
	.process-title {
		margin-bottom: 36px;
	}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/process-option/process-option.vue